export default [
    {
        name: "name",
        label: "Name",
        type: "String",
    },
    {
        name: "taggingsCount",
        label: "Taggings Count",
        type: "number",
    },
    {
        name: "createdAt",
        label: "Creation Date",
        type: "date",
    },
];
